import type { DocCategory } from '../registry';
import TroubleshootingIndex, { toc as troubleshootingIndexToc } from '../pages/troubleshooting/index';
import GpuNotDetected, { toc as gpuNotDetectedToc } from '../pages/troubleshooting/gpu-not-detected';
import PanelWontOpen, { toc as panelWontOpenToc } from '../pages/troubleshooting/panel-wont-open';
import CantSearch, { toc as cantSearchToc } from '../pages/troubleshooting/cant-search';
import AnalysisAndFiles, { toc as analysisAndFilesToc } from '../pages/troubleshooting/analysis-and-files';
import KnownIssues, { toc as knownIssuesToc } from '../pages/troubleshooting/known-issues';
import GetHelp, { toc as getHelpToc } from '../pages/get-help';

export const troubleshooting: DocCategory = {
  id: 'troubleshooting',
  label: 'Common issues',
  pages: [
    {
      slug: 'troubleshooting',
      title: 'Common issues',
      eyebrow: 'Common issues',
      description: 'Find your symptom and jump straight to the fix.',
      toc: troubleshootingIndexToc,
      Body: TroubleshootingIndex,
      related: [
        { label: "ClipRadar can't find my GPU", to: '/docs/troubleshooting/gpu-not-detected' },
        { label: "The Premiere panel won't open or is blank", to: '/docs/troubleshooting/panel-wont-open' },
        { label: 'Report a bug & get help', to: '/docs/get-help' },
      ],
    },
    {
      slug: 'troubleshooting/gpu-not-detected',
      title: "ClipRadar can't find my GPU",
      eyebrow: 'Common issues',
      description: 'The GPU-required failure — the red compute warning and how to clear it.',
      toc: gpuNotDetectedToc,
      Body: GpuNotDetected,
      related: [
        { label: 'AI models & your GPU', to: '/docs/concepts/models-and-your-gpu' },
        { label: 'System requirements', to: '/docs/reference/system-requirements' },
      ],
    },
    {
      slug: 'troubleshooting/panel-wont-open',
      title: "The Premiere panel won't open or is blank",
      eyebrow: 'Common issues',
      description: 'Fix the panel not appearing or not connecting to the desktop app.',
      toc: panelWontOpenToc,
      Body: PanelWontOpen,
      related: [
        { label: 'The Adobe Premiere Pro panel', to: '/docs/platforms/premiere-panel' },
        { label: 'Common issues', to: '/docs/troubleshooting' },
      ],
    },
    {
      slug: 'troubleshooting/cant-search',
      title: "I can't search",
      eyebrow: 'Common issues',
      description: "Work through the analyze → included → licensed checks when search won't return.",
      toc: cantSearchToc,
      Body: CantSearch,
      related: [
        { label: 'Analyzing your footage', to: '/docs/concepts/analyzing-media' },
        { label: 'Licensing & activation', to: '/docs/concepts/licensing' },
        { label: 'Get better search results', to: '/docs/guides/search-best-practices' },
      ],
    },
    {
      slug: 'troubleshooting/analysis-and-files',
      title: 'Analysis, missing files & speech problems',
      eyebrow: 'Common issues',
      description: 'The catch-all for analysis-time issues — interrupted downloads, moved files, damaged audio.',
      toc: analysisAndFilesToc,
      Body: AnalysisAndFiles,
      related: [
        { label: 'Fix speech & transcript problems', to: '/docs/guides/fix-speech-problems' },
        { label: 'Analyzing your footage', to: '/docs/concepts/analyzing-media' },
        { label: 'Common issues', to: '/docs/troubleshooting' },
      ],
    },
    {
      slug: 'troubleshooting/known-issues',
      title: 'Known issues',
      eyebrow: 'Common issues',
      description: 'An honest, running list of current limitations, updated each release.',
      toc: knownIssuesToc,
      Body: KnownIssues,
      related: [
        { label: 'Release notes', to: '/docs/release-notes' },
        { label: 'Report a bug & get help', to: '/docs/get-help' },
      ],
    },
    {
      slug: 'get-help',
      title: 'Report a bug & get help',
      eyebrow: 'Common issues',
      description: 'How to report a bug from inside the app, grab your logs, and reach the community.',
      toc: getHelpToc,
      Body: GetHelp,
      related: [
        { label: 'Common issues', to: '/docs/troubleshooting' },
        { label: 'Local & private', to: '/docs/concepts/local-and-private' },
      ],
    },
  ],
};
